export default __webpack_public_path__ + "static/media/Gellix-Medium.bba92fb3.woff2";